import { Util } from '@grandvisionhq/forms'
import { featureToggles } from '@grandvisionhq/www-next/configuration'

export const isPhoneNumber = (value: string): boolean => REGEX.PHONE_NUMBER.test(value)

export const isMobilePhoneNumber = (value: string): boolean => REGEX.MOBILE_PHONE_NUMBER.test(value)

const isExcludedPostalCodes = (value: string): boolean => {
  const number = Number(value)
  if (isNaN(number)) return false

  const isCeuta = number >= 51001 && number <= 51080
  const isMelilla = number >= 52000 && number <= 52080
  const isCanary1 = number >= 35000 && number <= 35660
  const isCanary2 = number >= 38001 && number <= 38917

  return featureToggles.allowAlternativeShippingState
    ? isCeuta || isMelilla
    : isCeuta || isMelilla || isCanary1 || isCanary2
}

export const isPostalCode = (value: string): boolean =>
  REGEX.POSTAL_CODE.test(value) && !isExcludedPostalCodes(value)

export const isFiscalCode = (value: string): boolean =>
  REGEX.FISCAL_CODE.test(value.replace(/ /g, ''))

export const isNifCode = (value: string): boolean => REGEX.NIF_CODE.test(value)

export const isValidPhoneNumber = (value: string): boolean => REGEX.PHONENUMBER_CODE.test(value)

const REGEX = {
  PHONE_NUMBER: /^[6-9]\d{8}$/,
  MOBILE_PHONE_NUMBER: /^[6-9]\d{8}$/,
  MOBILE_PHONE_NUMBER_AAB_ONLY: /^\+?\d{9,12}$/,
  POSTAL_CODE: /^\d{5}$/,
  FISCAL_CODE:
    /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
  NIF_CODE: /^([A-Za-z0-9])[0-9]{7}([A-Za-z0-9])$/,
  PHONENUMBER_CODE: /^\d{9}$/,
  ORDER_NUMBER: /^\d{7,12}$/, // supports order numbers with 7 to 12 digits
}

export const isOrderNumber: Util.validations.Validator = (value: string) =>
  REGEX.ORDER_NUMBER.test(value)

export const getTextLength = (text: string): number => {
  return text.length
}

const checkoutFieldsLengths: Record<string, number> & { default: number } = {
  fullName: 32,
  address_line_1: 32,
  default: 32,
  street: 32,
}

export const hasValidTextLength = (value: string, field: string): boolean => {
  const maxLength = checkoutFieldsLengths[field] ?? checkoutFieldsLengths.default
  return getTextLength(value) <= maxLength
}

export const isValidFullName = (input: string): boolean => {
  return Util.validations.isText(input) && hasValidTextLength(input, 'fullName')
}

export const isValidStreetName = (input: string): boolean => {
  return Util.validations.isStreetNameWithHouseNumber(input) && hasValidTextLength(input, 'street')
}

export const isValidStreetInfo = (input: string): boolean => {
  return Util.validations.isAddressLine(input) && hasValidTextLength(input, 'street')
}
